import * as React from 'react';

import { projectModelIdsForIriSelector } from 'src/selectors/projectModelIdsForIri';
import { projectModelItemsSelector } from 'src/selectors/projectModelItems';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useModelSelectItems = (iri?: string) => {
  const { projectId } = useRouterParams();

  const allModelItems = useReduxSelector(projectModelItemsSelector(projectId));

  const modelIds = useReduxSelector(
    projectModelIdsForIriSelector(projectId, iri)
  );

  return React.useMemo(() => {
    return {
      availableModels: allModelItems.filter(
        (item) => !modelIds.includes(item.value)
      ),
      currentModels: allModelItems.filter((item) =>
        modelIds.includes(item.value)
      ),
    };
  }, [allModelItems, modelIds]);
};
